import { atom } from "recoil";
const patinetRequestState = atom({
  key: "patinetRequestState", // unique ID (with respect to other atoms/selectors)
  default: { total: 0 }, // default value (aka initial value)
});
export { patinetRequestState };
